import React from 'react';
import { AppBar as MuiAppBar, Toolbar, Slide } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'; 

import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.default,
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: theme.zIndex.modal + 10,
    height: theme.headerHeight,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch'
  },
  relative: {
    position: 'relative'
  },
  spacer: {
    boxSizing: 'border-box',
    height: theme.headerHeight
  },
  toolbar: {
    justify: 'space-between',
    alignItems: 'center',
    flex: 1
  },
  offline: {
    textAlign: 'center',
    backgroundColor: '#f34c4c',
    zIndex: 999999,
    width: '100vw',
    color: 'white'
  }
}));

function AppBar({ children, style, variant, fixed, offlineWarning }) {

  const classes = useStyles();

  let appBar = (
    <MuiAppBar
      className={clsx(classes.root, {
        [classes.relative]: variant === 'relative'
      })}
      style={{ ...style }}
    >
      <Toolbar disableGutters className={classes.toolbar}>
        {children}
      </Toolbar>
    </MuiAppBar>
  );

  if (variant === 'hide') {
    appBar = <Slide appear={false} in={!trigger}>{appBar}</Slide>;
  }

  return (
    <>
      {appBar}
    </>
  );
}

export default AppBar;